/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseMetaNotificationConfig } from '../models/api-response-meta-notification-config';
import { getConfig } from '../fn/meta-notification-config-api/get-config';
import { GetConfig$Params } from '../fn/meta-notification-config-api/get-config';
import { updateConfig } from '../fn/meta-notification-config-api/update-config';
import { UpdateConfig$Params } from '../fn/meta-notification-config-api/update-config';

@Injectable({ providedIn: 'root' })
export class MetaNotificationConfigApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConfig()` */
  static readonly GetConfigPath = '/v1/api/ui/meta-notification/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig$Response(params: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMetaNotificationConfig>> {
    return getConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig(params: GetConfig$Params, context?: HttpContext): Observable<ApiResponseMetaNotificationConfig> {
    return this.getConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseMetaNotificationConfig>): ApiResponseMetaNotificationConfig => r.body)
    );
  }

  /** Path part for operation `updateConfig()` */
  static readonly UpdateConfigPath = '/v1/api/ui/meta-notification/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfig$Response(params: UpdateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMetaNotificationConfig>> {
    return updateConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfig(params: UpdateConfig$Params, context?: HttpContext): Observable<ApiResponseMetaNotificationConfig> {
    return this.updateConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseMetaNotificationConfig>): ApiResponseMetaNotificationConfig => r.body)
    );
  }

}
